import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truthySelectAnythingSelected',
})
export class TruthySelectAnythingSelectedPipe implements PipeTransform {
  public transform(values: string | number | (string | number)[]): boolean {
    if (typeof values === 'number') return true;
    if (typeof values === 'string' && values.length) return true;

    return Array.isArray(values) && values.length > 0;
  }
}
